<template>
    <div class="outer-container">
        <div class="page_mobile_abuoth flex-col">
            <div class="group_2 flex-col">
                <span class="text_12">康柏简介</span>
                <div class="group_9 flex-row">
                    <div class="image-text_2 flex-row">
                        <div class="image-text_3 flex-row">
                            <div class="about_content flex-row justify-between">

                                <div class="paragraph_container">
                                    <div class="paragraph_block">
                                        <div class="block_dot flex-col"></div>
                                        <span class="paragraph_1">
                                            康柏汉森深耕医药行业近二十年，是大健康领域风险控制服务的倡导者与实践者，作为值得信赖的风控合规合作伙伴，我们依托北京、上海、广州等10大运营中心，数十位资深项目经理与数百位专业核查团队，为大健康领域100余家全球领先企业提供全链路风控与合规管理服务。
                                        </span>
                                    </div>
                                    <div class="paragraph_block">
                                        <div class="block_dot flex-col"></div>
                                        <span class="paragraph_1">
                                            康柏汉森拥有企业健康管理智慧中心，通过AI人工智能工具集、多源数据交叉验证系统及合规风险评估模型等，精准识别销售舞弊、渠道窜货及供应链合规隐患。聚焦外资企业本土化合规痛点，为企业提供定制化解决方案。
                                        </span>
                                    </div>
                                    <div class="paragraph_block">
                                        <div class="block_dot flex-col"></div>
                                        <span class="paragraph_1">
                                            康柏汉森专注于企业风险诊断与合规管理，深刻理解企业经营健康与业务成长的迫切需求，为企业提供业务风控与合规管理的多样化产品以及整体服务解决方案，助力客户达成“风险可视、决策可依、增长可持续”。
                                        </span>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
                <div class="about_img_container">
                    <div class="about_img flex-col"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {

            };
        },
        methods: {}
    };
</script>
<style scoped lang="css">
    .outer-container {
        display: flex;
        justify-content: center;
        width: 100%;
    }
    .page_mobile_abuoth {
        position: relative;
        max-width: 1200px;
        height: 100%;
        overflow: hidden;
        margin: 0 auto;
        align-items: center;
    }

    .group_2 {
        align-items: center;
        width: 100%;
        position: relative;
        padding: 10px 10px 25px 10px; /* 添加左右各10px的边距 */
        box-sizing: border-box; /* 确保padding包含在宽度内 */
        margin: 0 auto;
        align-items: center;
    }

    .text_12 {
        overflow-wrap: break-word;
        color: rgba(30, 30, 30, 1);
        font-size: 32px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 45px;
        margin: 0;
    }

    .group_9 {
        position: relative;
        width: 100%;
        height: auto;
        align-self: center;
        margin-top: 24px;
        margin: 0 auto;
        padding: 20px;
        box-sizing: border-box;
    }

    .image-text_2 {
        position: relative;
    }

    .image-text_3 {
        position: relative;
        width: 100%;
        text-align: center;
    }

    .about_content {
        display: flex;
        width: 100%;
        gap: 10px;
    }

    .block_dot {
        background-color: rgba(0, 120, 126, 0.7);
        width: 10px;
        height: 10px;
        margin: 7px 0 8px 0;
    }

    .paragraph_container {
        display: flex;
        flex-direction: column;
        gap: 20px;
        width: 100%;
        max-width: 700px;
    }

    .paragraph_block {
        display: flex;
        align-items: flex-start;
        gap: 10px;
    }

    .paragraph_1 {
        width: 100%;
        overflow-wrap: break-word;
        color: rgba(85, 85, 85, 1);
        font-size: 24px;
        text-align: justify;
        line-height: 38px;
        padding-left: 8px;
        padding-right: 10px;
    }


    .about_img_container {
        width: 100%;
        max-width: 690px;
        height: 170px;
        overflow: hidden;
        position: relative;
        margin-top: 10px;
    }

    .about_img {
        background-image: url(../../../assets/home/chpc_about_01.png);
        background-size: cover;
        background-position: center;
        position: absolute;
        width: 100%;
        height: 100%;
        transition: transform 0.3s ease;
    }
    .about_img:hover {
        transform: scale(1.2);
    }

    @media (max-width: 460px) {
        .paragraph_1 {
            font-size: 14px;
            line-height: 24px;
        }
        .text_12 {
            font-size: 20px;
            margin-left: 10px;
        }

        .group_9 {
            padding: 10px;
        }
    }

</style>
